import { Component, Input, OnInit } from '@angular/core';
import { WatcherService } from 'src/app/services/watcher.service';

export interface ShopAndShipBrandsItemInterface {
  brandName: string;
  brandLogo: string;
  brandLink?: string;
}

@Component({
  selector: 'lp-countries-brands-grid',
  styleUrls: ['brands-grid.component.css'],
  templateUrl: 'brands-grid.component.html',
})
export class ShopAndShipBrandsGridComponent implements OnInit {
  @Input() title: string;
  @Input() brands: ShopAndShipBrandsItemInterface[];
  lang: string;
  constructor(
    private watcherService: WatcherService
  ) {}

  ngOnInit(): void {
    this.watcherService.getLang().subscribe((lang) => {
      this.lang = lang;
    });
  }
}
